// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"EventTooltip_tooltipContainer__+7hvd","header":"EventTooltip_header__GbGnm"};